export const findTouchById = (touches: TouchList, identifier: number) => {
  for (let index = 0; index < touches.length; index += 1) {
    const touch = touches[index];
    if (touch && touch.identifier === identifier) {
      return touch;
    }
  }
  return undefined;
};

type Position = { x: number; y: number };
export const getDistance2D = (p1: Position, p2: Position) => Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);

export enum Environment {
  tagLocal = 'local',
  tagStaging = 'staging',
  tagProduction = 'production',
  fsLocal = 'fs-local',
  fsProduction = 'fs-production',
  fsStaging = 'fs-staging',
}

export const appSrcByEnv: Record<Environment, string> = {
  [Environment.tagLocal]: process.env.IFRAME_HOST || 'https://local-qa-assistant.abtasty.com:5000',
  [Environment.tagStaging]: 'https://staging-qa-assistant.abtasty.com',
  [Environment.tagProduction]: 'https://qa-assistant.abtasty.com',
  [Environment.fsProduction]: 'https://qa-assistant.flagship.io',
  [Environment.fsLocal]: process.env.IFRAME_HOST || 'https://local-qa-assistant.flagship.io:5000',
  [Environment.fsStaging]: 'https://staging-qa-assistant.flagship.io',
};
